import { Injectable } from '@angular/core';
import { CustomerSettings } from 'src/sb-tools/typescript/models/customer-settings.model';
import { CommonCategories } from '../models/common-categories.model';
import { CommunityUserExtended } from '../models/community-user-extended.model';
import { SocialMediaInstallationStatuses } from '../models/social-media-installation-statuses.dto';
import { Signatures } from '../models/signatures.model';
import { AppDTO } from '../models/dto/app.dto';

@Injectable({
    providedIn: 'root',
})
export class CommonDataService {
    apps: AppDTO[];
    categories: CommonCategories = new CommonCategories();
    community;
    communityName;
    customerSettings: CustomerSettings;
    folderStat;
    isDisableTicketsLoading: boolean;
    isTicketTakenOverFromBot: boolean;
    isOnlyMyTicketsFilterDefault: boolean;
    isOneTime = false;
    isRightPanelOpened = true;
    // todo: don't mix inbox data  amd common data service (create separated services)
    isViewWithTicketList: boolean;
    language;
    outboundEmailAddresses?: string[];
    searchQuery: string;
    signatures: Signatures = new Signatures();
    socialMediaStatuses: any = new SocialMediaInstallationStatuses();
    socialMediaStatusesLoaded: boolean;
    user: CommunityUserExtended = new CommunityUserExtended();
    xToken;
}
